
const urlParamToObj = paramString => {
  let result = {};

  if (!paramString || paramString === "") {
    return result;
  }
  paramString = decodeURI(paramString);

  if (paramString[0] === "?") {
    paramString = paramString.substr(1);
  }

  let prmList = paramString.split('&');
  prmList.forEach(prmStr => {
    let prm = prmStr.split("=", 2);
    if (prm.length === 2) {
      result[prm[0]] = prm[1];
    }
  });

  return result;
};

const objToUrlParam = obj => {
  if (Object.keys(obj).length === 0) {
    return "";
  }
  const params = Object.keys(obj).map(prop => {
    return prop + "=" + obj[prop];
  });

  return "?" + params.join("&");
};

export { urlParamToObj, objToUrlParam };
